/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Montserrat w wersji zmiennej: jeden plik na alfabet zamiast osobnych
// plikow dla kazdej grubosci (bylo 254 KB, jest ok. 107 KB). Przegladarka
// pobiera tylko alfabety uzyte na stronie, czyli latin i latin-ext.
require("@fontsource-variable/montserrat/wght.css")

require('./src/styles/global.css')

const SCROLL_DURATION = 300
const NAV_OFFSET = 80

function scrollToHash(hash) {
  const id = hash.replace(/^#/, '')
  if (!id) return

  const el = document.getElementById(id)
  if (!el) return

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET)
    return
  }

  const target = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET
  const start = window.scrollY
  const distance = target - start
  const startTime = performance.now()

  const step = (now) => {
    const t = Math.min((now - startTime) / SCROLL_DURATION, 1)
    const eased = 1 - (1 - t) ** 3
    window.scrollTo(0, start + distance * eased)
    if (t < 1) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

function handleAnchorClick(event) {
  const link = event.target.closest('a[href^="#"]')
  if (!link) return

  const hash = link.getAttribute('href')
  if (!hash || hash === '#') return

  const id = hash.slice(1)
  if (!document.getElementById(id)) return

  event.preventDefault()
  scrollToHash(hash)
  window.history.pushState(null, '', hash)
}

// Wyrejestruj service worker (i wyczysc cache) u uzytkownikow ktorzy
// mieli poprzednia wersje strony z gatsby-plugin-offline.
// Bez tego service worker dalej serwowalby stary content.
exports.onClientEntry = () => {
  if (typeof navigator === 'undefined') return
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister())
    }).catch(() => {})
  }
  if (typeof caches !== 'undefined') {
    caches.keys().then((keys) => {
      keys.forEach((key) => caches.delete(key))
    }).catch(() => {})
  }
}

// Licznik klikniec w przyciski (WhatsApp, Stripe, Instagram, telefon, mail,
// linki do ebooka). Cloudflare Web Analytics liczy wejscia, ale nie klikniecia.
// Wysylamy tylko typ przycisku, sciezke podstrony i napis na przycisku:
// zadnych cookies ani identyfikatorow. Odbiera to /api/k (Netlify przekazuje
// do aplikacji wysylkowej, patrz static/_redirects). Szanujemy "Do Not Track".
function clickEvent(href) {
  if (!href) return null
  if (href.startsWith('https://wa.me/')) return 'whatsapp'
  if (href.includes('buy.stripe.com')) return 'stripe'
  if (href.includes('instagram.com')) return 'instagram'
  if (href.startsWith('tel:')) return 'telefon'
  if (href.startsWith('mailto:')) return 'mail'
  if (/^\/ebook(\/|\?|$)/.test(href)) return 'ebook'
  return null
}

function trackClick(e) {
  try {
    const link = e.target.closest && e.target.closest('a')
    if (!link) return
    const event = clickEvent(link.getAttribute('href'))
    if (!event) return
    if (navigator.doNotTrack === '1' || navigator.webdriver) return
    if (window.location.hostname !== 'walczoforme.pl') return

    const label = (link.getAttribute('aria-label') || link.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 60)
    const body = JSON.stringify({ e: event, p: window.location.pathname, l: label })
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/k', new Blob([body], { type: 'text/plain' }))
    } else {
      fetch('/api/k', { method: 'POST', body, keepalive: true }).catch(() => {})
    }
  } catch (err) {
    // Pomiar nigdy nie moze zepsuc klikniecia.
  }
}

exports.onInitialClientRender = () => {
  document.addEventListener('click', handleAnchorClick)
  document.addEventListener('click', trackClick, true)

  if (window.location.hash) {
    requestAnimationFrame(() => scrollToHash(window.location.hash))
  }
}

exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return false
  return [0, 0]
}

exports.onRouteUpdate = ({ location }) => {
  if (location.hash) {
    requestAnimationFrame(() => scrollToHash(location.hash))
  } else {
    window.scrollTo(0, 0)
  }
}
